export default __webpack_public_path__ + "static/media/Page_not_found.2ee7b43c.png";